import { UtilityService } from 'src/app/components/shared/services/utility.service';

import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep } from 'lodash';
import { State } from 'src/app/modals/state.modal';
import { ShippingAddress, UserServiceModal } from 'src/app/modals/userservice.modal';
import { OrderService } from '../../shared/services/order.service';
import { RestApiService } from '../../shared/services/restapi.service';
import { UserService } from '../../shared/services/user.service';
import { Cart1Service } from '../../shared/services/cart1.service';
import * as _ from 'lodash';
import { PersistentService } from '../../shared/services/persistent.service';
import { DefaultCountry } from 'src/app/constant';
@Component({
    selector: 'app-shipping-address',
    templateUrl: './shippingaddress.component.html',
    styleUrls: ['./shippingaddress.component.scss']
})
export class ShippingAddressComponent implements OnInit {
    public userService: UserServiceModal;
    public newShipping: ShippingAddress = {} as ShippingAddress;
    public isStateRestrict: boolean;
    constructor(
        private router: Router,
        public apiService: RestApiService,
        public user: UserService,
        public orderService: OrderService,
        public translate: TranslateService,
        public titleService: Title,
        public cart1Service: Cart1Service,
        public utilityService: UtilityService,
        public persistentService: PersistentService
    ) {
        this.userService = user.userServiceModal;
        this.userService.newshippingAddress = {} as ShippingAddress;
        if (!this.utilityService.isEmptyObject(this.userService.customerData.DefaultShippingAddress)){
            this.user.setShippingAddress();
            this.userService.newshippingAddress.CountryCode =  this.userService.shippingAddress?.CountryCode?.toUpperCase() || this.userService.customerData?.DefaultShippingAddress.MainCountry?.toUpperCase();
            this.userService.newshippingAddress.CountryCode = this.userService.newshippingAddress?.CountryCode?.toUpperCase();
        } else {
            this.userService.newshippingAddress.CountryCode =  sessionStorage.getItem('selectedCountry').toUpperCase() || this.userService.shippingAddress?.CountryCode?.toUpperCase();
        }

        // check restricated states
        if (this.userService.restrictedStates.length) {
            _.each(this.userService.restrictedStates, (state) => {
                if (this.userService.shippingAddress.Region && (state).toLowerCase() === (this.userService.shippingAddress.Region).toLowerCase()) {
                    this.isStateRestrict = true;
                }
            });
        }

    }
    public allowedCountries: any = [];
    states: Array<State> = [];
    ngOnInit() {
        this.translate.get('global_Company_Title').subscribe((text: string) => {
            this.titleService.setTitle(this.translate.instant('pagetitle_shipping') + ' | ' + text);
          });
        this.apiService.getActiveCountries().subscribe(data => {
            this.allowedCountries = data?.Data ? data?.Data : data;
            if(this.allowedCountries?.length > 0){
                this.allowedCountries = this.allowedCountries.filter(ac => ac.CountryCode?.toLowerCase() !== "jp");
            }
        }, () => { });
        this.getCountryState();
    }

    getCountryState(country?: string) {
        this.apiService.getStates(country || DefaultCountry).subscribe((result) => {
            sessionStorage.setItem((country || DefaultCountry) + 'State', JSON.stringify(result.Data));
            this.states = result.Data;
            this.userService.selectedCountry = country || DefaultCountry;
        },
            (error) => {
            }, () => {

            });
    }

    nextStep(isChanged?: boolean) {
        if (this.userService.newshippingAddress && this.userService.newshippingAddress.CountryCode && (this.userService.newshippingAddress.CountryCode.toUpperCase() !== sessionStorage.getItem('selectedCountry').toUpperCase())) {
            sessionStorage.setItem('selectedCountry', this.userService.newshippingAddress.CountryCode);
            const allowedCountries = JSON.parse(sessionStorage.getItem('allowedCountries'));
            _.each(allowedCountries.Data, (item) => {
                if (item.CountryCode.toLowerCase() == this.userService.newshippingAddress.CountryCode.toLowerCase()) {
                    sessionStorage.setItem('selectedLanguageCode', item.CountryLanguages[0].LanguageCode);
                }
            });
        }
        if (isChanged) {
            if (this.userService.newshippingAddress && this.userService.newshippingAddress.Street1 && this.userService.newshippingAddress.PostalCode) {
                this.userService.selectedShippingMethod = "";
                this.userService.newshippingAddress.FullName = ((this.userService.newshippingAddress.FirstName || '') + ' ' + (this.userService.newshippingAddress.LastName || '')).trim();
                this.userService.shippingAddress = cloneDeep(this.userService.newshippingAddress);
                this.userService.isAddressChanged = true;
                this.userService.isEditAutoshipAddressChanged = this.utilityService.getAutoshipEditFlag() ? true : false;
                // Persist the updated address to localStorage so it survives navigation
                sessionStorage.setItem('userService', JSON.stringify(this.userService));
            }
        } else {
            this.userService.newshippingAddress = {};
        }
        this.orderService.calculateOrder().then(() => {
            if (this.utilityService.getAutoshipEditFlag() && this.persistentService.retailData.CurrentSelectedAutoOrder) {
                this.router.navigate(['/checkout'], { 
                    queryParams: { autoshipId: this.persistentService.retailData.CurrentSelectedAutoOrder } 
                });
            } else {
                this.router.navigate(['/checkout']);
            }
        }).catch(() => {
            if (this.utilityService.getAutoshipEditFlag() && this.persistentService.retailData.CurrentSelectedAutoOrder) {
                this.router.navigate(['/checkout'], { 
                    queryParams: { autoshipId: this.persistentService.retailData.CurrentSelectedAutoOrder } 
                });
            } else {
                this.router.navigate(['/checkout']);
            }
        });
    }
}
